export const images = {
  logoLogin: require('./auth/logo-struck.jpg'),
  logistic: require('./logistic.jpg'),
  backgroud_login: require('./auth/backgroud_login.jpg'),
  backgroud_login_new: require('./auth/bg_login_new.png'),
  logo: require('./logo.png'),
  logoString: require('./logoString.png'),
  logoStruck: require('./logoStruck.png'),
  logoReport: require('./report/logo.png')
}
